

const primaryColour = '#2A2D3A';
const AccentColour = '#BFB593';


export const APP_THEME = {
    primaryColour,
    AccentColour
}